@if (isLoading) {
  <div class="mb-6">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
}
@if (!isLoading) {
  <div class="cancel-additional-services-page px-3 m-5">
    @if (!hasSpecialParams) {
      <div class="py-4 padding-2-5rem-1-5rem">
        <button class="gap-2 flex items-center" (click)="goBack()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="size-6 stroke-[#0D6EFD]">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
          <p class="font-medium text-md text-[#0D6EFD]">
            {{ 'PRICING.ADDITIONAL_SERVICES.EDIT_ADDITIONAL_SERVICES' | transloco }}
          </p>
        </button>
      </div>
    }
    <div>
      @if (additionalServices.length > 0) {
        <div class="self-stretch p-4">
          <div class="text-xl font-semibold mb-3">{{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_SERVICES' | transloco }}</div>
          <div class="text-lg font-medium mb-4">{{ 'HANDLE_BOOKING.UNCHECK_BOXES' | transloco }}
          </div>
          @for (service of additionalServices; track trackByServiceId($index, service)) {
            <div
              class="self-stretch rounded-xl border border-zinc-200 p-4 mb-3">
              <div class="flex items-center gap-3">
                <mat-checkbox [checked]="isServiceSelected(service)" [disabled]="isServiceDisabled(service)"
                  (change)="onServiceToggle(service, $event)">
                </mat-checkbox>
                <div class="flex-1">
                  <div class="leading-loose">
                    {{ getServiceName(service.name) | translateAttribute }}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if (additionalServices.length === 0) {
        <div class="mb-6 text-slate-700">
          <p>{{ 'PARKIFLY.MANAGE_BOOKING.NO_ADDITIONAL_SERVICES_FOUND' | transloco }}</p>
        </div>
      }
      @if(hasDeletionTargets) {
        <div class="self-stretch p-3 m-4 mt-2 rounded-lg border-primary-bg-light">
          <div class="flex items-center justify-between gap-4">
            <div class="flex items-start gap-2">
              <div class="text-lg text-primary">
                <span>{{ 'HANDLE_BOOKING.REFUND_AMOUNT' | transloco }}</span>
                <span class="font-bold">{{ getUncheckedServicesAmount() }} SEK</span>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="pt-4 pb-8 mx-4 md:pt-8 md:flex md:justify-start md:flex-row-reverse gap-2">
        <button
          class="w-full px-8 py-3 bg-[#dd4e44] hover:bg-[#dd4e44] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-white"
          (click)="cancelServices()" [disabled]="!hasDeletionTargets || isLoading">
          {{ 'PARKIFLY.MANAGE_BOOKING.CANCEL_SERVICES' | transloco }}
        </button>
        <button
          class="w-full px-8 py-3 bg-[#1B3777] hover:bg-[#1B3777] rounded-[4px] font-medium text-md leading-6 flex justify-center md:mb-0 md:w-auto mb-4 md:mb-0 text-white"
          (click)="resetSelections()" [disabled]="!hasDeletionTargets || isLoading">
          {{ 'FORM.CANCEL_CHANGES' | transloco }}
        </button>
      </div>
    </div>
  </div>
}